import {
  Field,
  GetStaticComponentProps,
  useComponentProps,
  withDatasourceCheck,
} from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/component-props';

import styles from './MagicCards.module.scss';

type MagicCardsProp = ComponentProps & {
  fields: {
    Products: Field<string>;
  };
};

export type PIMProduct = {
  description: string;
  familyId: number;
  name: string;
  pageUrl: string;
  supportPageUrl: string;
  hasBluetoothPairingGuide: boolean;
  productName: string;
  segmentType: string;
  summary: string;
  thumbnailUrl: string;
  title: string;
  uniqueSellingPoint: string;
  groupId: string;
};

export type PIMProductList = PIMProduct[];

const ProductTile = ({ title }: PIMProduct) => {
  return <div>{title}</div>;
};
const MagicCards = (props: MagicCardsProp): JSX.Element => {
  const productList = useComponentProps<PIMProductList>(props.rendering.uid);

  return (
    <div className={styles.root}>
      {productList && productList.map((item) => <ProductTile {...item} key={item.name} />)}
    </div>
  );
};

export const getStaticProps: GetStaticComponentProps = async (rendering) => {
  if (rendering.fields?.Products) {
    const products = rendering.fields?.Products as Field;
    const res = await fetch(
      `https://productcatalogueapi.jabra.com//v1/family/filter?ids=${products.value}&include=available&marketLocale=en-us`
    ).then((res) => res.json());
    // console.log(res);
    return res;
  } else {
    return null;
  }
};

export default withDatasourceCheck()<MagicCardsProp>(MagicCards);
